import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import ChatList from '.'
import { CHAT_SCREEN_URL } from '../../../consts'

const routes = () => {
  return (
    <React.Fragment>
      <PrivateRoute
        key={CHAT_SCREEN_URL}
        exact={true}
        path={CHAT_SCREEN_URL}
        component={ChatList}
      />
    </React.Fragment>
  );
};

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/routes.js